// extracted by css-extract-rspack-plugin
export default {"SidesheetContent":"QqTsB","FlexScrollContainer":"aJtdu","OverflowAuto":"CPwLu","InsightsTab":"Ppyeq","TabSibling":"N7Vao"};